import { Record } from "immutable";

const defaults = {
    id: "",
    user: {},
    images: {},
    created_time: "",
    caption: {},
    user_has_liked: "",
    likes: {},
    tags: [],
    filter: "",
    comments: {},
    type: "",
    link: "",
    location: {},
    attribution: "",
    users_in_photo: [],
    videos: {},
};

class Instagram extends Record(defaults) {}

export default Instagram;
